module.exports = __webpack_public_path__ + "static/media/123.2c9ca466.jpg";